import { useEffect, useState } from 'react';
// import ChatMessage from './ChatMessage';
// import MessageInput from './MessageInput';
import { apiFetch } from 'utils/api';
import ChatHome from './ChatHome';
import ChatConversation from './ChatConversation';
import BackButton from '../../ui-component/customs/BackButton';

export default function ChatPage({ chatId, hasChats, chatTitle, onAutoRename, onChatCreated }) {
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [didAutoRename, setDidAutoRename] = useState(false);

  useEffect(() => {
    if (!chatId) return;
    loadMessages();
  }, [chatId]);

  useEffect(() => {
    setDidAutoRename(false);
  }, [chatId]);

  const loadMessages = async () => {
    try {
      const data = await apiFetch(`/messages/${chatId}`);
      setMessages(data || []);
    } catch (err) {
      console.error('Failed to load messages', err);
    }
  };

  function normalizeUserText(input) {
    if (typeof input !== 'string') {
      console.warn('normalizeUserText received non-string:', input);
      return '';
    }
    return (
      input
        .replace(/[ \t]+/g, ' ')
        // normalize line breaks
        .replace(/\n{3,}/g, '\n\n')
        // trim edges
        .trim()
    );
  }

  const handleSend = async (payload) => {
    // 🔹 Extract text safely
    const rawText = typeof payload === 'string' ? payload : payload?.text || payload?.content || '';

    const text = normalizeUserText(rawText);
    if (!text) return;

    const shouldAutoRename = chatTitle === 'New Chat' && !didAutoRename && text.length > 10;

    let activeChatId = chatId;

    if (!activeChatId) {
      const chat = await apiFetch('/chats', {
        method: 'POST',
        body: JSON.stringify({
          firstMessage: text,
          chatType: 'general'
        })
      });

      onChatCreated?.(chat);
      activeChatId = chat.id;
    }

    setMessages((prev) => [...prev, { role: 'user', content: text }]);
    setIsTyping(true);

    try {
      const data = await apiFetch(`/messages/${activeChatId}/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          content: text,
          attachments: payload?.attachments || []
        })
      });

      if (shouldAutoRename) {
        const result = await apiFetch(`/chats/${activeChatId}/auto-title`, {
          method: 'POST',
          body: JSON.stringify({ message: text })
        });
        onAutoRename?.(activeChatId, result.title);
        setDidAutoRename(true);
      }

      setMessages((prev) => [...prev, { role: 'assistant', content: data.reply }]);
    } catch (err) {
      console.error(err);
    } finally {
      setIsTyping(false);
    }
  };

  // Show home screen ONLY if no chats exist
  if (!chatId && !hasChats) {
    return (
      <>
        <BackButton />
        <ChatHome onSend={handleSend} />;
      </>
    );
  }

  if (!chatId && hasChats) {
    return (
      <>
        <BackButton />
        <ChatHome onSend={handleSend} />;
      </>
    );
  }

  return (
    <>
      <BackButton />
      <ChatConversation messages={messages} isTyping={isTyping} onSend={handleSend} />;
    </>
  );
}
